"use client";

import Link from "next/link";
import { MdiChevronLeft } from "@/assets/icons/mdi-chevron-left";
import { cn } from "@/utils/cn";
import { useTranslations } from "next-intl";

export const BreadcrumbHomepage = ({
  className,
  url,
}: {
  className?: string;
  url: string;
}) => {
  const t = useTranslations("breadcrumb.homepage");

  return (
    <section
      className={cn(
        "flex w-full flex-row justify-start px-4 pt-8 ph:px-24 md:px-48 lg:px-72 xl:px-96",
        className,
      )}
    >
      <div>
        <Link href={url} className="group font-light text-white">
          <div className="flex items-center gap-1">
            <MdiChevronLeft className="h-5 w-5 text-white group-hover:text-primary" />
            <span className="duration-300 group-hover:text-primary">
              {t("back")}
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};
